import { toast } from "react-toastify"

type ResponseHanldeProps = {
  apiResponse: any
  successMessage: boolean
  hideError?: boolean
  permError?: string
}

function useResponseHandle(props: ResponseHanldeProps) {
  const { apiResponse, successMessage, hideError, permError } = props

  if (apiResponse?.data?.status_code == 401) {
    return { isAuthorized: false, data: null, statusCode: 401 }
  } else if (apiResponse?.data?.status_code == 403) {
    toast.error(
      permError ||
        "You're trying to perform an action that you're not allowed to, please contact your administrator for details.",
    )
    return { isAuthorized: false, data: null, statusCode: 403 }
  } else if (apiResponse?.data?.status_code !== 200) {
    !hideError && toast.error(apiResponse?.data?.display_message)
    return {
      isAuthorized: true,
      data: apiResponse?.data?.error,
      statusCode: apiResponse?.data?.status_code,
    }
  } else {
    if (successMessage) {
      toast.success(apiResponse?.data?.display_message)
    }
    return {
      isAuthorized: true,
      data: apiResponse?.data?.data,
      statusCode: 200,
    }
  }
}

export default useResponseHandle
